export { default as PostsListLayout } from './component';
